"use strict";

calculationService.service("LivingAllowanceCalcService", function(ApplicationService) {
    let familyData;
    this.calculate = () => {
        let FamCount = ApplicationService.getFamCount();
        for (let i = 0; i < FamCount; i++) {
            familyData = ApplicationService.getAwardData().family[i];
            familyData.awardData.livingAllowance.childAllowance = total_child_allowance(i);
            familyData.awardData.livingAllowance.livingAllowance = total_living_allowance();
        }
    };

    let total_child_allowance = (i) => {
        let local = {};
        // Child Allowance
        local.CAT = 0;
        let res = 0;
        for (let x = 0; x < ApplicationService.getAwardData().applicants.length; x++) {
            res += parseInt(ApplicationService.getAwardData().applicants[x]["Res_F" + (i + 1)]);
        }        

        local.applicant_count = familyData.edit_sums.Applicant_Count;
        local.tuition_count   = ApplicationService.getAwardData().applicants.length;
        local.child_count     = familyData.edit_sums.Child_Count;
        local.other_chi_count = parseInt(local.applicant_count) - parseInt(local.tuition_count) +
            parseInt(local.child_count);
        local.CAT =  ((res + local.other_chi_count) * familyData.thresholds.Thresh_Allow_Per_Child);
        return Math.round(local.CAT);
    };

    let total_living_allowance = () => {
        familyData.edit_sums.Exp_Added = totalAddedAllowances(); 
        let TBA = parseInt(familyData.thresholds.Thresh_Living_Allowance) +
            parseInt(familyData.awardData.livingAllowance.childAllowance) + parseInt(familyData.edit_sums.Exp_Added);
        return Math.round(TBA);
    };

    let totalAddedAllowances = () => {
        let allowances = familyData.addedAllowance;
        let sum = 0;
        // if (allowances.length==0) sum=parseInt(familyData.edit_sums.Exp_Added);
        for (let i = 0; i < allowances.length; i++) {
            sum += parseInt(allowances[i].amount);
        }
        return sum;
    };
});
